import { Client } from "@core/Client";
import { Phase } from "@core/Logic/Logic";
import { Constants } from "@core/Utils/Constants";
import { IMAXAClient } from "./IMAXAClient";
import { Authenticated, PlayboardMode } from "./IMAXAProtocol";

export class DEVClient extends IMAXAClient {

  private deckOfCards = [
    "1c", "2c", "3c", "4c", "5c", "6c", "7c", "8c", "9c", "10c", "jc", "qc", "kc",
    "1h", "2h", "3h", "4h", "5h", "6h", "7h", "8h", "9h", "10h", "jh", "qh", "kh",
    "1d", "2d", "3d", "4d", "5d", "6d", "7d", "8d", "9d", "10d", "jd", "qd", "kd",
    "1s", "2s", "3s", "4s", "5s", "6s", "7s", "8s", "9s", "10s", "js", "qs", "ks",
  ];
  private availableCards = [];
  private givenCards = [];
  private isDoubleZero = false;
  private rouletteGame = {
    config: {
      betPresets: {
        BigSeries: [{X:1,Y:2},{X:5,Y:5},{X:9,Y:1},{X:13,Y:1},{X:15,Y:5},{X:19,Y:4},{X:23,Y:3}],
        NassaBet:[{X:0,Y:0},{X:9,Y:1},{X:14,Y:5},{X:18,Y:3},{X:23,Y:3}],
        Orphans:[{X:2,Y:5},{X:5,Y:1},{X:11,Y:3},{X:13,Y:3},{X:23,Y:5}],
        Serie58:[{X:5,Y:3},{X:8,Y:4},{X:11,Y:5},{X:16,Y:2},{X:19,Y:1},{X:23,Y:1}],
        ZeroGame:[{X:0,Y:0},{X:9,Y:1},{X:18,Y:3},{X:23,Y:3}]
      },
      "default-audio": "",
      playboardMode: PlayboardMode.LESFIGURES_PLUS,
      betTable: [[
        { numbers: [], type: 0, },
        { numbers: [37], type: 1, },
        // { numbers: [ 0 ], type: 0, }, // For single zero
        { numbers: [], type: 0, },
        { numbers: [0,], type: 1, },
        { numbers: [], type: 0, },
        { numbers: [], type: 0, },
        { numbers: [], type: 0, },
        { numbers: [], type: 0, },
        { numbers: [], type: 0, },
        { numbers: [0, 32,], type: 2, },
        { numbers: [9, 31,], type: 2, },
      ],
      [{ numbers: [0, 1, 2, 3,], type: 4, },
      this.isDoubleZero ? { numbers: [37, 3,], type: 2, } : { numbers: [0, 3,], type: 2, }, // Double Zero has separate covers
      { numbers: [0, 2, 3,], type: 3, },
      { numbers: [0, 2,], type: 2, },
      { numbers: [0, 1, 2,], type: 3, },
      { numbers: [0, 1,], type: 2, },
      { numbers: [0, 1, 2, 3,], type: 4, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [15, 32,], type: 2, },
      { numbers: [9, 22,], type: 2, },],
      [{ numbers: [1, 2, 3,], type: 3, },
      { numbers: [3,], type: 1, },
      { numbers: [2, 3,], type: 2, },
      { numbers: [2,], type: 1, },
      { numbers: [1, 2,], type: 2, },
      { numbers: [1,], type: 1, },
      { numbers: [1, 2, 3,], type: 3, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [15, 19,], type: 2, },
      { numbers: [18, 22,], type: 2, },],
      [{ numbers: [1, 2, 3, 4, 5, 6,], type: 6, },
      { numbers: [3, 6,], type: 2, },
      { numbers: [2, 3, 5, 6,], type: 4, },
      { numbers: [2, 5,], type: 2, },
      { numbers: [1, 2, 4, 5,], type: 4, },
      { numbers: [1, 4,], type: 2, },
      { numbers: [1, 2, 3, 4, 5, 6,], type: 6, },
      { numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,], type: 11, },
      { numbers: [], type: 0, },
      { numbers: [4, 19,], type: 2, },
      { numbers: [18, 29,], type: 2, },],
      [{ numbers: [4, 5, 6,], type: 3, },
      { numbers: [6,], type: 1, },
      { numbers: [5, 6,], type: 2, },
      { numbers: [5,], type: 1, },
      { numbers: [4, 5,], type: 2, },
      { numbers: [4,], type: 1, },
      { numbers: [4, 5, 6,], type: 3, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [4, 21,], type: 2, },
      { numbers: [7, 29,], type: 2, },],
      [{ numbers: [4, 5, 6, 7, 8, 9,], type: 6, },
      { numbers: [6, 9,], type: 2, },
      { numbers: [5, 6, 8, 9,], type: 4, },
      { numbers: [5, 8,], type: 2, },
      { numbers: [4, 5, 7, 8,], type: 4, },
      { numbers: [4, 7,], type: 2, },
      { numbers: [4, 5, 6, 7, 8, 9,], type: 6, },
      { numbers: [], type: 0, },
      { numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,], type: 8, },
      { numbers: [2, 21,], type: 2, }, { numbers: [7, 28,], type: 2, },],
      [{ numbers: [7, 8, 9,], type: 3, },
      { numbers: [9,], type: 1, },
      { numbers: [8, 9,], type: 2, },
      { numbers: [8,], type: 1, },
      { numbers: [7, 8,], type: 2, },
      { numbers: [7,], type: 1, },
      { numbers: [7, 8, 9,], type: 3, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [2, 25,], type: 2, },
      { numbers: [12, 28,], type: 2, },],
      [{ numbers: [7, 8, 9, 10, 11, 12,], type: 6, },
      { numbers: [9, 12,], type: 2, },
      { numbers: [8, 9, 11, 12,], type: 4, },
      { numbers: [8, 11,], type: 2, },
      { numbers: [7, 8, 10, 11,], type: 4, },
      { numbers: [7, 10,], type: 2, },
      { numbers: [7, 8, 9, 10, 11, 12,], type: 6, },
      { numbers: [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36,], type: 10, },
      { numbers: [], type: 0, }, { numbers: [17, 25,], type: 2, },
      { numbers: [12, 35,], type: 2, },],
      [{ numbers: [10, 11, 12,], type: 3, },
      { numbers: [12,], type: 1, },
      { numbers: [11, 12,], type: 2, },
      { numbers: [11,], type: 1, },
      { numbers: [10, 11,], type: 2, },
      { numbers: [10,], type: 1, },
      { numbers: [10, 11, 12,], type: 3, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [17, 34,], type: 2, },
      { numbers: [3, 35,], type: 2, },],
      [{ numbers: [10, 11, 12, 13, 14, 15,], type: 6, },
      { numbers: [12, 15,], type: 2, },
      { numbers: [11, 12, 14, 15,], type: 4, },
      { numbers: [11, 14,], type: 2, },
      { numbers: [10, 11, 13, 14,], type: 4, },
      { numbers: [10, 13,], type: 2, },
      { numbers: [10, 11, 12, 13, 14, 15,], type: 6, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [6, 34,], type: 2, },
      { numbers: [3, 26,], type: 2, },],
      [{ numbers: [13, 14, 15,], type: 3, },
      { numbers: [15,], type: 1, },
      { numbers: [14, 15,], type: 2, },
      { numbers: [14,], type: 1, },
      { numbers: [13, 14,], type: 2, },
      { numbers: [13,], type: 1, },
      { numbers: [13, 14, 15,], type: 3, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [6, 27,], type: 2, },
      { numbers: [0, 26,], type: 2, },],
      [{ numbers: [13, 14, 15, 16, 17, 18,], type: 6, },
      { numbers: [15, 18,], type: 2, },
      { numbers: [14, 15, 17, 18,], type: 4, },
      { numbers: [14, 17,], type: 2, },
      { numbers: [13, 14, 16, 17,], type: 4, },
      { numbers: [13, 16,], type: 2, },
      { numbers: [13, 14, 15, 16, 17, 18,], type: 6, },
      { numbers: [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35,], type: 9, },
      { numbers: [], type: 0, },
      { numbers: [13, 27,], type: 2, },
      { numbers: [], type: 0, },],
      [{ numbers: [16, 17, 18,], type: 3, },
      { numbers: [18,], type: 1, },
      { numbers: [17, 18,], type: 2, },
      { numbers: [17,], type: 1, },
      { numbers: [16, 17,], type: 2, },
      { numbers: [16,], type: 1, },
      { numbers: [16, 17, 18,], type: 3, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },
      { numbers: [13, 36,], type: 2, },
      { numbers: [], type: 0, },],
      [{ numbers: [16, 17, 18, 19, 20, 21,], type: 6, },
      { numbers: [18, 21,], type: 2, },
      { numbers: [17, 18, 20, 21,], type: 4, },
      { numbers: [17, 20,], type: 2, },
      { numbers: [16, 17, 19, 20,], type: 4, },
      { numbers: [16, 19,], type: 2, },
      { numbers: [16, 17, 18, 19, 20, 21,], type: 6, },
      { numbers: [], type: 0, },
      { numbers: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,], type: 8, },
      { numbers: [11, 36,], type: 2, },
      { numbers: [], type: 0, },],
      [{ numbers: [19, 20, 21,], type: 3, },
      { numbers: [21,], type: 1, },
      { numbers: [20, 21,], type: 2, },
      { numbers: [20,], type: 1, },
      { numbers: [19, 20,], type: 2, },
      { numbers: [19,], type: 1, },
      { numbers: [19, 20, 21,], type: 3, },
      { numbers: [], type: 0, }, { numbers: [], type: 0, },
      { numbers: [11, 30,], type: 2, }, { numbers: [], type: 0, },],
      [{ numbers: [19, 20, 21, 22, 23, 24,], type: 6, },
      { numbers: [21, 24,], type: 2, }, { numbers: [20, 21, 23, 24,], type: 4, },
      { numbers: [20, 23,], type: 2, }, { numbers: [19, 20, 22, 23,], type: 4, }, { numbers: [19, 22,], type: 2, },
      { numbers: [19, 20, 21, 22, 23, 24,], type: 6, }, { numbers: [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,], type: 9, },
      { numbers: [], type: 0, }, { numbers: [8, 30,], type: 2, }, { numbers: [], type: 0, },], [{ numbers: [22, 23, 24,], type: 3, },
      { numbers: [24,], type: 1, }, { numbers: [23, 24,], type: 2, }, { numbers: [23,], type: 1, }, { numbers: [22, 23,], type: 2, },
      { numbers: [22,], type: 1, }, { numbers: [22, 23, 24,], type: 3, }, { numbers: [], type: 0, }, { numbers: [], type: 0, },
      { numbers: [8, 23,], type: 2, }, { numbers: [], type: 0, },], [{ numbers: [22, 23, 24, 25, 26, 27,], type: 6, },
      { numbers: [24, 27,], type: 2, }, { numbers: [23, 24, 26, 27,], type: 4, }, { numbers: [23, 26,], type: 2, },
      { numbers: [22, 23, 25, 26,], type: 4, }, { numbers: [22, 25,], type: 2, }, { numbers: [22, 23, 24, 25, 26, 27,], type: 6, },
      { numbers: [], type: 0, }, { numbers: [], type: 0, }, { numbers: [10, 23,], type: 2, }, { numbers: [], type: 0, },],
      [{ numbers: [25, 26, 27,], type: 3, }, { numbers: [27,], type: 1, }, { numbers: [26, 27,], type: 2, },
      { numbers: [26,], type: 1, }, { numbers: [25, 26,], type: 2, }, { numbers: [25,], type: 1, }, { numbers: [25, 26, 27,], type: 3, },
      { numbers: [], type: 0, }, { numbers: [], type: 0, }, { numbers: [5, 10,], type: 2, }, { numbers: [], type: 0, },],
      [{ numbers: [25, 26, 27, 28, 29, 30,], type: 6, }, { numbers: [27, 30,], type: 2, }, { numbers: [26, 27, 29, 30,], type: 4, },
      { numbers: [26, 29,], type: 2, }, { numbers: [25, 26, 28, 29,], type: 4, }, { numbers: [25, 28,], type: 2, },
      { numbers: [25, 26, 27, 28, 29, 30,], type: 6, }, { numbers: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29, 31, 33, 35,], type: 10, },
      { numbers: [], type: 0, }, { numbers: [5, 24,], type: 2, }, { numbers: [], type: 0, },], [{ numbers: [28, 29, 30,], type: 3, },
      { numbers: [30,], type: 1, }, { numbers: [29, 30,], type: 2, }, { numbers: [29,], type: 1, }, { numbers: [28, 29,], type: 2, },
      { numbers: [28,], type: 1, }, { numbers: [28, 29, 30,], type: 3, }, { numbers: [], type: 0, }, { numbers: [], type: 0, },
      { numbers: [16, 24,], type: 2, }, { numbers: [], type: 0, },], [{ numbers: [28, 29, 30, 31, 32, 33,], type: 6, },
      { numbers: [30, 33,], type: 2, }, { numbers: [29, 30, 32, 33,], type: 4, }, { numbers: [29, 32,], type: 2, },
      { numbers: [28, 29, 31, 32,], type: 4, }, { numbers: [28, 31,], type: 2, }, { numbers: [28, 29, 30, 31, 32, 33,], type: 6, },
      { numbers: [], type: 0, }, { numbers: [25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,], type: 8, }, { numbers: [16, 33,], type: 2, },
      { numbers: [], type: 0, },], [{ numbers: [31, 32, 33,], type: 3, }, { numbers: [33,], type: 1, }, { numbers: [32, 33,], type: 2, },
      { numbers: [32,], type: 1, }, { numbers: [31, 32,], type: 2, }, { numbers: [31,], type: 1, }, { numbers: [31, 32, 33,], type: 3, },
      { numbers: [], type: 0, }, { numbers: [], type: 0, }, { numbers: [1, 33,], type: 2, }, { numbers: [], type: 0, },],
      [{ numbers: [31, 32, 33, 34, 35, 36,], type: 6, }, { numbers: [33, 36,], type: 2, }, { numbers: [32, 33, 35, 36,], type: 4, },
      { numbers: [32, 35,], type: 2, }, { numbers: [31, 32, 34, 35,], type: 4, }, { numbers: [31, 34,], type: 2, },
      { numbers: [31, 32, 33, 34, 35, 36,], type: 6, }, { numbers: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,], type: 11, },
      { numbers: [], type: 0, }, { numbers: [1, 20,], type: 2, }, { numbers: [], type: 0, },], [{ numbers: [34, 35, 36,], type: 3, },
      { numbers: [36,], type: 1, }, { numbers: [35, 36,], type: 2, }, { numbers: [35,], type: 1, }, { numbers: [34, 35,], type: 2, },
      { numbers: [34,], type: 1, }, { numbers: [34, 35, 36,], type: 3, }, { numbers: [], type: 0, }, { numbers: [], type: 0, },
      { numbers: [14, 20,], type: 2, }, { numbers: [], type: 0, },], [{ numbers: [], type: 0, },
      { numbers: [3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36,], type: 7, }, { numbers: [], type: 0, },
      { numbers: [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35,], type: 7, }, { numbers: [], type: 0, },
      { numbers: [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34,], type: 7, }, { numbers: [], type: 0, },
      { numbers: [], type: 0, }, { numbers: [], type: 0, }, { numbers: [14, 31,], type: 2, },
      { numbers: [], type: 0, },],
      //---les figures---------------------------------------
      [{ numbers: [1, 10, 19, 28], type: 12, },
      { numbers: [2, 11, 20, 29], type: 12, },
      { numbers: [3, 12, 21, 30], type: 12, },
      { numbers: [4, 13, 22, 31], type: 12, },
      { numbers: [5, 14, 23, 32], type: 12, },
      { numbers: [6, 15, 24, 33], type: 12, },
      { numbers: [7, 16, 25, 34], type: 12, },
      { numbers: [8, 17, 26, 35], type: 12, },
      { numbers: [9, 18, 27, 36], type: 12, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },],
      [{ numbers: [1, 10, 19, 28], type: 13, },
      { numbers: [2, 11, 20, 29], type: 13, },
      { numbers: [3, 12, 21, 30], type: 13, },
      { numbers: [4, 13, 22, 31], type: 13, },
      { numbers: [5, 14, 23, 32], type: 13, },
      { numbers: [6, 15, 24, 33], type: 13, },
      { numbers: [7, 16, 25, 34], type: 13, },
      { numbers: [8, 17, 26, 35], type: 13, },
      { numbers: [9, 18, 27, 36], type: 13, },
      { numbers: [], type: 0, },
      { numbers: [], type: 0, },]
        //---les figures---------------------------------------
      ],
      betTypes: [{ index: 0, multiplier: 0, name: "Unknown (void)", },
      { index: 1, multiplier: 36, name: "Straight up", },
      { index: 2, multiplier: 18, name: "Split", },
      { index: 3, multiplier: 12, name: "Trio", },
      { index: 4, multiplier: 9, name: "Corner", },
      { index: 5, multiplier: 7, name: "Five numbers", },
      { index: 6, multiplier: 6, name: "Six numbers", },
      { index: 7, multiplier: 3, name: "Horizontal line", },
      { index: 8, multiplier: 3, name: "Third", },
      { index: 9, multiplier: 2, name: "Red / Black", },
      { index: 10, multiplier: 2, name: "Odd / Even", },
      { index: 11, multiplier: 2, name: "Half", },
      { index: 12, multiplier: 9, name: "Les Figure", },
      { index: 13, multiplier: 82, name: "Tout Va", }
      ],
      stakes: [{
        betTypeMax: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
        betTypeMin: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        playboardMax: 555555,
        playboardMin: 1,
        maxNumBets: 125,
        maxWin: 555555,
        chipValues: [0, 1, 2, 5, 10, 20],
      }],
      selectedStake: 0,
    }, 
    stream: {
      type: "NanoCosmos",
      sources: [{
        index: 0,
        label: "video",
        url: "ly21-03.4knh.com:8082/7072",
        streamname: "1234",
        token: ""
      }]
    },
    historyNumbers: [1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30, 1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30],
    players: [],
    state: {
      ID: 123,
      timeLeft: {
        absolute: 3000,
        percent: 25,
      },
      phase: 20,
      phaseSubID: 32,
      winNumber: -1,
      /*jackpot: {
        enabled: 1,
        luckyNumber: 35,
        levels: new Array<{
          level: number;
          pot: number;
          status: string;
        }>()
      }*/
    },
    host: {
      info:{
        RNGType: "imaxaGaming",
        'double-zero': this.isDoubleZero,
        stakeChangeAllowed: false,
        startVoteEnabled:true,
        roundTime: 3000
      }
    },
    unfinished: null,
    maxHistorySize: 200,
    /*jackpot: {
      type: "lucky",
      enabled: 1,
      luckyNumber: 35,
      levels: [
        {
          level: 1,
          pot: 1000000,
          status: "Counting",
          minBet: 10
        },
        {
          level: 2,
          pot: 100000,
          status: "Counting",
          minBet: 5
        },
        {
          level: 3,
          pot: 10000,
          status: "Counting",
          minBet: 2.5
        },
      ]
    }*/
  }
  private videoPokerGame = {
    config: {
      paytable: [
        [{ value: 1, type: 0 }, { value: 2, type: 1 }, { value: 3, type: 2 }, { value: 4, type: 3 }, { value: 6, type: 4 }, { value: 9, type: 5 }, { value: 25, type: 6 }, { value: 50, type: 7 }, { value: 250, type: 8 }],
        [{ value: 2, type: 0 }, { value: 4, type: 1 }, { value: 6, type: 2 }, { value: 8, type: 3 }, { value: 12, type: 4 }, { value: 18, type: 5 }, { value: 50, type: 6 }, { value: 100, type: 7 }, { value: 500, type: 8 }],
        [{ value: 3, type: 0 }, { value: 6, type: 1 }, { value: 9, type: 2 }, { value: 12, type: 3 }, { value: 18, type: 4 }, { value: 27, type: 5 }, { value: 75, type: 6 }, { value: 150, type: 7 }, { value: 750, type: 8 }],
        [{ value: 4, type: 0 }, { value: 8, type: 1 }, { value: 12, type: 2 }, { value: 16, type: 3 }, { value: 24, type: 4 }, { value: 36, type: 5 }, { value: 100, type: 6 }, { value: 200, type: 7 }, { value: 1000, type: 8 }],
        [{ value: 5, type: 0 }, { value: 10, type: 1 }, { value: 15, type: 2 }, { value: 20, type: 3 }, { value: 30, type: 4 }, { value: 45, type: 5 }, { value: 125, type: 6 }, { value: 250, type: 7 }, { value: 4000, type: 8 }]],
      betTypes: [
        { index: 0, value: 100, name: "Coin 1", },
        { index: 1, value: 500, name: "Coin 2", },
        { index: 2, value: 2500, name: "Coin 3", },
        { index: 3, value: 8000, name: "Coin 4", },
        { index: 4, value: 12000, name: "Coin 5", }
      ],
      stakes: [{
        betTypeMax: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
        betTypeMin: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
        playboardMax: 555555,
        playboardMin: 1,
        maxNumBets: 125,
        maxWin: 555555,
        chipValues: [0, 1, 2, 5, 10, 20],
      }],
      selectedStake: 0,
    },
    historyCards: [1, 2, 3, 4, 5, 33, 20, 19, 5, 0, 11, 16, 25, 28, 30, 33, 12, 5, 6, 7, 8, 9, 10, 0, 12, 24, 31, 32, 33, 30],
    players: [],
    state: {
      ID: 123,
      phase: 20,
      phaseSubID: 32,
      winCards: null,
      jackpot: {
        enabled: 1,
        luckyNumber: 35,
        levels: new Array<{
          level: number;
          pot: number;
          status: string;
        }>()
      }
    },
    unfinished: null,
    maxHistorySize: 200,
    host: {
      info:{
        RNGType: "imaxaGaming",
        'double-zero': null,
        stakeChangeAllowed: false,
        startVoteEnabled:false,
        roundTime: 0
      }
    },
    jackpot: {
      type: "lucky",
      enabled: 1,
      luckyNumber: 35,
      levels: [
        {
          level: 1,
          pot: 1000000,
          status: "Counting",
          minBet: 100
        },
        {
          level: 2,
          pot: 100000,
          status: "Counting",
          minBet: 50
        }/*,
        {
          level: 3,
          pot: 10000,
          status: "Counting",
          minBet: 25
        },*/
      ]
    }
  }

  constructor(address: string) {
    super(address);
  }

  override CreateNewSocket(): void {
    this.ResetDeck();
    let payload = {
      balance: [1111, 222, 333, 4444, 5555],
      currency: "EUR",//"NONE"
      denomination: 0.01,
      // stakes: [{
      //   betTypeMax: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
      //   betTypeMin: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      //   playboardMax: 555555,
      //   playboardMin: 1,
      //   maxNumBets: 125,
      //   maxWin: 555555,
      //   chipValues: [0, 1, 2, 5, 10, 20],
      // }],
      game: this.rouletteGame,
      history: [],
      account: {
        UID: "Player_0",
        name: "Player_0",
        nickname: "Nickname123",
        session: "sid",
        demo: false,
        payoutEnabled: true,
        logoutSupported: true,
        showUsername: true
      },
      provider: {
        config: "",
        domain: "DOMAIN123",
        id: 123,
        name: "askdo",
        authenticationRequired: true
      },
      spectator: false,
      payoutEnabled: true,
      demo: false,
      authenticationRequired: false,
      currencyValue: 1,
      pilotSeat: false,
      locale: "en_en"//"it_it"
    } as unknown as Authenticated
    setTimeout(() => this.OnInit(true, {
      rawData: "",
      receivedTS: 123123,
      type: "",
      contextID: 2131,
      sentTS: 123123,
      payload: {
        data: payload
      }
    }), 1000);

    setTimeout(() => { this.FakeRouletteRNG(true); }, 3000);
  }

  onOpen(handler: (ev: Event) => any): void {
    handler(false as any)
    /*setTimeout(() => {
      this.OnError(new IMAXAError({ sentTS: 123123, rawData: { payload: { type: 123, code: 512 } }, receivedTS: 123123, type: "error", payload: { type: 123132, code: 512 }, contextID: 123}))
    }, 2000);*/
    // this.testCroupierPhases()
  }
  /*
    private testCroupierPhases(): void {
      setTimeout(() => {
        //this.OnServerEvent(new IMAXAClientMEssage({ sentTS: 123123, rawData: { payload: { type: 123, code: 512 } }, receivedTS: 123123, type: "error", payload: { type: 123132, code: 512 }, contextID: 123}))
        this.OnServerEvent("game-state-changed", { name: "phase", new: 31 })
        this.OnServerEvent("game-state-changed", { name: "winNumber", new: 0 })
        setTimeout(() => {
          this.OnServerEvent("game-state-changed", { name: "phase", new: 2 })
        }, 1500);
      }, 3000);
    }*/

  get Connected(): boolean {
    return true;
  }

  onClose(): void {
  }

  SendRequest(): number {
    return 1;
  }

  PlayAFakeRouletteGame(hasJackpot: boolean): void {
    // console.log("TEST RNG : BETS ARE OPEN");
    this.OnServerEvent("game-state-changed", { name: "phase", new: Phase.BETS_OPEN_STATE });
    this.OnServerEvent("game-state-changed", { name: "winNumber", new: -1 });
    Client.logic.OnUpdateProgressBar(100);
    Client.logic.onUpdateSendBetsTime(8000);

    let luckyNum;
    let selectedLevel;
    if (hasJackpot) {
      Client.game.events.emit(Constants.EVENTS.JACKPOT_STATE_LUCKY_NUMBER, -1);
      selectedLevel = Math.round(Math.random() * 2) - Math.round(Math.random());
      Client.game.events.emit(Constants.EVENTS.JACKPOT_STATE_LUCKY_LEVEL, selectedLevel);
    }

    // setTimeout(() => {
    //   Client.logic.OnUpdateProgressBar(75);
    //   Client.logic.onUpdateSendBetsTime(7000);
    // }, 1000);
    // setTimeout(() => {
    //   Client.logic.OnUpdateProgressBar(60);
    //   Client.logic.onUpdateSendBetsTime(6000);
    // }, 2000);
    // setTimeout(() => {
    //   Client.logic.OnUpdateProgressBar(50);
    //   Client.logic.onUpdateSendBetsTime(5000);
    // }, 3000);
    // setTimeout(() => {
    //   Client.logic.OnUpdateProgressBar(35);
    //   Client.logic.onUpdateSendBetsTime(4000);
    // }, 4000);
    // setTimeout(() => {
    //   // console.log("TEST RNG : HURRY UP");
    //   this.OnServerEvent("game-state-changed", { name: "phase", new: Phase.BETS_ARE_CLOSING_STATE });
    //   Client.logic.OnUpdateProgressBar(25);
    //   Client.logic.onUpdateSendBetsTime(3000);
    // }, 5000);
    // setTimeout(() => {
    //   Client.logic.OnUpdateProgressBar(10);
    //   Client.logic.onUpdateSendBetsTime(2000);
    // }, 6000);
    // setTimeout(() => {
    //   Client.logic.OnUpdateProgressBar(2);
    //   Client.logic.onUpdateSendBetsTime(1000);
    // }, 7000);
    // setTimeout(() => {
    //   // console.log("TEST RNG : BETS CLOSED");
    //   this.OnServerEvent("game-state-changed", { name: "phase", new: Phase.BETS_CLOSED });
    //   this.OnServerEvent("game-state-changed", { name: "phase", new: Phase.WAITING_WIN_NUMBER_STATE });
    //   Client.logic.OnUpdateProgressBar(0);
    //   Client.logic.onUpdateSendBetsTime(0);
    // }, 8000);
    // setTimeout(() => {
    //   // console.log("TEST RNG : RESULT");
    //   let winNum = Math.floor(Math.random() * 36);
    //   if (hasJackpot && selectedLevel > -1) {
    //     luckyNum = Math.floor(Math.random() * 36);
    //     Client.game.events.emit(Constants.EVENTS.JACKPOT_STATE_LUCKY_NUMBER, luckyNum);
    //   }
    // }, 9000);
    // setTimeout(() => {
    //   console.log("TEST RNG : RESULT");
    //   let winNum = Math.floor(Math.random() * 36);

    //   if (hasJackpot && selectedLevel > -1) {
    //     if (luckyNum == winNum) {
    //       Client.game.events.emit(Constants.EVENTS.JACKPOT_WON, { totalWon: 100 + Math.random() * 50000 });
    //     }
    //   }
    //   this.OnServerEvent("game-state-changed", { name: "phase", new: Phase.READING_WIN_NUMBER_STATE });
    //   this.OnServerEvent("game-state-changed", { name: "winNumber", new: winNum });
    // }, 11000);
  }

  FakeRouletteRNG(hasJackpot: boolean): void {
    // console.log("STARTING TEST RNG");
    this.PlayAFakeRouletteGame(hasJackpot);
    setInterval(() => {
      this.PlayAFakeRouletteGame(hasJackpot);
    }, 13000);
  }

  //------------------------Video poker debugging stuff------------------------
  ResetDeck(): void {
    this.availableCards = deepCopy(this.deckOfCards);
    this.shuffleArray(this.availableCards);
    this.givenCards = [];
  }

  GiveCards(): void {
    for (let i = 0; i < 5; i++) {
      this.givenCards.push(this.availableCards.pop());
    }
    this.OnServerEvent("game-state-changed", { name: "winNumber", new: this.givenCards });
  }

  SecondSend(cardsGivenBack: number[]): void {
    //how many were given back
    let count = 0;
    //given cards get shuffled back <- ?????? unsure
    cardsGivenBack.forEach(number => {
      if (number == 1) {
        this.availableCards.push(this.givenCards[number]);
        count++;
      }
    });
    this.givenCards = [];
    this.shuffleArray(this.availableCards);

    for (let i = 0; i < count; i++) {
      this.givenCards.push(this.availableCards.pop());
    }
    this.OnServerEvent("game-end", { name: "winNumber", new: this.givenCards });

    this.ResetDeck();
  }

  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  }
  //------------------------------------------------------------------------
}
